import ContentPanel from './ContentPanel';

export default ContentPanel;



// WEBPACK FOOTER //
// ./src/components/ContentPanel/index.js